<app-header></app-header>
<app-navbar [selected]="'taxes'"></app-navbar>
<div class="d-flex">
    <aside role="complementary" [attr.aria-label]="'asideDescription' | translate">
        <app-sidebar [subItems]="subLinks" [items]="links"></app-sidebar>
    </aside>
    <main class="ps-5 w-100">
        <div class="row" [formGroup]="filterParams">
            <div class="modelinput col-4">
                <label>{{ 'model.choseTaxModel' | translate }}</label>
                <select class="form-select" aria-label="taxModel1" formControlName="taxModel">
                    <option [value]="" hidden></option>
                    <option *ngFor="let model of this.modelResponse.listRateModelDto" [value]="model.idRateModel">
                        {{(('academicTaxes.' + model.typology) | translate)+ ' - ' +
                        model.rateModelTraductionDto?.[0]?.shortDescription + ' - ' +
                        model.codeRateModel}}
                    </option>
                </select>
            </div>
        </div>

        <div *ngIf="filterParams.get('taxModel')?.value" class="row mb-3">
            <div class="text-end d-flex align-items-center col-12 mt-2 justify-content-between">
                <h2 class="mb-3 textformat">{{ 'learningResource.learningResources' |
                    translate }}</h2>
                <button type="button" class="btn custombutton" (click)="newModel()"
                    [disabled]="this.learningResourceFeeResponse && this.learningResourceFeeResponse.listLearningResourceFeeDto.length>0">{{
                    'buttons.newRegister' | translate
                    }}</button>
            </div>
        </div>
        <div *ngIf="hasLearningResources">
            <fieldset>
                <table id="table1" class="table mb-3" role="grid" [attr.aria-label]="'model.choseTaxModel' | translate">
                    <thead>
                        <tr role="row">
                            <th scope="col">
                                <span class="visually-hidden">{{ 'seleccionarFila' | translate }}</span>
                            </th>
                            <th scope="col">{{ 'learningResource.description' | translate }}</th>
                            <th scope="col">{{ 'learningResource.typeMaterial' | translate }}</th>
                            <th scope="col">{{ 'learningResource.chargeShipping' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of this.learningResourceFeeResponse.listLearningResourceFeeDto"
                            [ngClass]="{ 'resaltado': selectedRowId === row.idOwnLearningResourceRate }" role="row">
                            <td role="gridcell">
                                <input type="radio" id="radio-{{row.idOwnLearningResourceRate}}" name="checkbox1"
                                    [checked]="selectedRowId === row.idOwnLearningResourceRate"
                                    (click)="toggleRow(row)" />
                                <label [for]="'radio-' + row.idOwnLearningResourceRate" class="visually-hidden">
                                    {{ "seleccionarFilaCon" | translate }}:
                                    {{ 'learningResource.description' | translate }} {{
                                    row.ownLearningResourceRateTraductionDto?.[0]?.description || 'N/A' }},
                                    {{ 'learningResource.typeMaterial' | translate }} {{ ('materialType.' +
                                    row.materialType) | translate }},
                                    {{ 'learningResource.chargeShipping' | translate }} {{ row.chargeShipping ?
                                    ('learningResource.S' | translate) : ('learningResource.N' | translate) }}
                                </label>
                            </td>
                            <td role="gridcell">{{ row.ownLearningResourceRateTraductionDto?.[0]?.description }}</td>
                            <td role="gridcell">{{ (('materialType.' + row.materialType) | translate) }}</td>
                            <td role="gridcell">{{ row.chargeShipping ? ('learningResource.S' | translate) :
                                ('learningResource.N' | translate) }}</td>
                        </tr>
                    </tbody>
                </table>
            </fieldset>

            <!-- Controles de paginación -->
            <div class="mt-2" *ngIf="this.learningResourceFeeResponse.pageDto">
                <app-paginator [isStart]="this.learningResourceFeeResponse.pageDto.start"
                    [isEnd]="this.learningResourceFeeResponse.pageDto.end"
                    [currentPage]="this.learningResourceFeeResponse.pageDto.currentPage"
                    [totalPages]="this.learningResourceFeeResponse.pageDto.pages"
                    [numberRecord]="this.learningResourceFeeResponse.pageDto.records"
                    [sizePage]="this.learningResourceFeeResponse.pageDto.pageSize">
                </app-paginator>
            </div>

        </div>
        <div *ngIf="selectedRowId || isCreate">
            <div>
                <div class="separator mt-5"></div>
                <h2 class="mb-3 mt-4 textformat">{{ 'learningResource.learningResources' |
                    translate }}</h2>
            </div>
            <form [formGroup]="learningResourceForm">
                <div class="row">
                    <div class="col-4 mb-3">
                        <label for="typeMaterial">{{ 'learningResource.typeMaterial' | translate }}<span>
                                *</span></label>
                        @if(isCreate){
                        <select class="form-select" formControlName="typeMaterial" id="typeMaterial"
                            name="typeMaterial">
                            <option value="C">{{ 'materialType.C' | translate }}</option>
                        </select>
                        }@else{
                        <input type="text" class="form-control" name="typeMaterial1" id="typeMaterial1" [value]="getLearningResourceDescription()" disabled />
                        }

                    </div>
                    <div class="form-check col-4 mb-3 d-flex align-items-center justify-content-center">
                        <input class="form-check-input" type="checkbox" id="chargeShipping" name="chargeShipping"
                            formControlName="chargeShipping" />
                        <label class="form-check-label ms-2" for="chargeShipping">{{ 'learningResource.chargeShipping' |
                            translate }}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 mb-3">
                        <label for="descriptionCat">{{ 'learningResource.catDescription' | translate }}<span>
                                *</span></label>
                        <input type="text" class="form-control" name="descriptionCat" id="descriptionCat"
                            placeholder="Ingrese la descripción en catalán" formControlName="descriptionCat" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 mb-3">
                        <label for="descriptionCast">{{ 'learningResource.castDescription' | translate }}<span>
                                *</span></label>
                        <input type="text" id="descriptionCast" name="descriptionCast" class="form-control"
                            placeholder="Ingrese la descripción en castellano" formControlName="descriptionCast" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 mb-3">
                        <label for="descriptionIng">{{ 'learningResource.engDescription' | translate }}<span>
                                *</span></label>
                        <input type="text" id="descriptionIng" name="descriptionIng" class="form-control"
                            placeholder="Ingrese la descripción en inglés" formControlName="descriptionIng" />
                    </div>
                </div>
                <div class="row d-flex">
                    <div class="col-12 mt-4">
                        <button type="button" class="btn cancelbutton me-2" (click)="onCancel()">Cancelar</button>
                        <button type="button" class="btn custombutton" (click)="saveLearningResourceFee()">
                            {{ !isCreate ? ('buttons.modify' | translate) : ('buttons.save' | translate) }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
        <app-alert-component [isOk]="isCreated" [isDanger]="isError" [message]="errorMessage"
            (close)="this.isCreated = isError = false"></app-alert-component>
        <div *ngIf="selectedRowId">
            <div>
                <div class="separator mt-4"></div>
                <div class="row mt-4 mb-3">
                    <h2 class="mb-3 textformat col-4">{{ 'learningResource.materialPrices'
                        | translate }}</h2>

                    <div class="text-end d-flex align-items-center col-8 mt-2 justify-content-end">
                        <button type="button" class="btn custombutton " id="clone" (click)="clone()"
                            [disabled]="!selectedMaterialPricesRowId">{{'Clonar' | translate }}</button>
                        <button type="button" class="btn custombutton ms-2" (click)="newRegister()">{{
                            'buttons.newRegister' |
                            translate }}</button>
                    </div>
                </div>
            </div>

            <fieldset>
                <table id="table1" class="table mb-3" role="grid"
                    [attr.aria-label]="'learningResource.materialPrices' | translate">
                    <thead>
                        <tr role="row">
                            <th scope="col">
                                <span class="visually-hidden">{{ 'seleccionarFila' | translate }}</span>
                            </th>
                            <th scope="col">{{ 'learningResource.price' | translate }}</th>
                            <th scope="col">{{ 'learningResource.ivaPattern' | translate }}</th>
                            <th scope="col">{{ 'learningResource.firstInstallment' | translate }}</th>
                            <th scope="col">{{ 'learningResource.startDate' | translate }}</th>
                            <th scope="col">{{ 'learningResource.endDate' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of this.learningResourceFeePriceResponse.listLearningResourceFeePriceDto"
                            [ngClass]="{ 'resaltado': selectedMaterialPricesRowId === row.idOwnLearningResourcePriceDetail }"
                            role="row">
                            <td role="gridcell">
                                <input type="radio" id="radio-{{row.idOwnLearningResourcePriceDetail}}" name="checkbox2"
                                    [checked]="selectedMaterialPricesRowId === row.idOwnLearningResourcePriceDetail"
                                    (click)="toggleRowMaterialPrices(row)">
                                <label [for]="'radio-' + row.idOwnLearningResourcePriceDetail" class="visually-hidden">
                                    {{ "seleccionarFilaCon" | translate }}:
                                    {{ 'learningResource.price' | translate }} {{ row.price }},
                                    {{ 'learningResource.ivaPattern' | translate }} {{ row.vatPatternDto?.codePatternVat
                                    ||
                                    'N/A' }},
                                    {{ 'learningResource.firstInstallment' | translate }} {{ row.firstTermPayment ?
                                    ('learningResource.S' | translate) : ('learningResource.N' | translate) }},
                                    {{ 'learningResource.startDate' | translate }} {{ row.startDate | date:'dd/MM/yyyy'
                                    }},
                                    {{ 'learningResource.endDate' | translate }} {{ row.endDate | date:'dd/MM/yyyy' }}
                                </label>
                            </td>
                            <td role="gridcell">{{ row.price }}</td>
                            <td role="gridcell">{{ row.vatPatternDto?.codePatternVat }}</td>
                            <td role="gridcell">{{ row.firstTermPayment ? ('learningResource.S' | translate) :
                                ('learningResource.N' | translate) }}</td>
                            <td role="gridcell">{{ row.startDate | date: 'dd/MM/yyyy' }}</td>
                            <td role="gridcell">{{ row.endDate | date: 'dd/MM/yyyy' }}</td>
                        </tr>
                    </tbody>
                </table>
            </fieldset>

            <!-- Controles de paginación -->
            <div class="mt-2" *ngIf="this.learningResourceFeePriceResponse.pageDto">
                <app-paginator [isStart]="this.learningResourceFeePriceResponse.pageDto.start"
                    [isEnd]="this.learningResourceFeePriceResponse.pageDto.end"
                    [currentPage]="this.learningResourceFeePriceResponse.pageDto.currentPage"
                    [totalPages]="this.learningResourceFeePriceResponse.pageDto.pages"
                    [numberRecord]="this.learningResourceFeePriceResponse.pageDto.records"
                    [sizePage]="this.learningResourceFeePriceResponse.pageDto.pageSize">
                </app-paginator>
            </div>

            <div *ngIf="selectedMaterialPricesRowId || isCreateMaterialPrices || isClone">
                <div>
                    <div class="separator mt-5"></div>
                    <h2 class="mb-3 mt-4 textformat">{{ 'learningResource.materialPrices'
                        | translate }}</h2>
                </div>
                <form [formGroup]="learningResourcePriceForm">
                    <div class="row">
                        <!-- Fecha de alta -->
                        <div class="mb-3 col-6 ">
                            <label for="startDate" class="form-label">
                                {{ 'academicTaxes.registrationDate' | translate }}<span>
                                    *</span>
                            </label>
                            <input type="date" class="form-control" id="startDate" name="startDate"
                                formControlName="startDate" />
                        </div>

                        <!-- Fecha de baja -->
                        <div class="mb-3 col-6 ">
                            <label for="endDate" class="form-label">
                                {{ 'academicTaxes.endDate' | translate }}
                            </label>
                            <input type="date" class="form-control" id="endDate" name="endDate"
                                formControlName="endDate" />
                        </div>
                    </div>

                    <div class="row">
                        <!-- Primer plazo -->
                        <div class="mb-3 col-6 ">
                            <label for="firstTermPayment" class="form-label">
                                {{ 'academicTaxes.firstInstallment' | translate }}<span>
                                    *</span>
                            </label>
                            <select class="form-select" id="firstTermPayment" name="firstTermPayment"
                                formControlName="firstTermPayment">
                                <option value="true">{{ 'academicTaxes.S' | translate }}</option>
                                <option value="false">{{ 'academicTaxes.N' | translate }}</option>
                            </select>
                        </div>

                        <!-- Precio -->
                        <div class="mb-3 col-6 ">
                            <label for="price" class="form-label">
                                {{ 'academicTaxes.price' | translate }}<span>
                                    *</span>
                            </label>
                            <input type="number" class="form-control" id="price" name="price" formControlName="price"
                                [min]="0" />
                        </div>
                    </div>

                    <div class="row">
                        <!-- Patrón de IVA -->
                        <div class="mb-3 col-6 ">
                            <label for="idVatPattern" class="form-label">
                                {{ 'academicTaxes.ivaPattern' | translate }}<span>
                                    *</span>
                            </label>
                            <select class="form-select" id="idVatPattern" name="idVatPattern"
                                formControlName="idVatPattern">
                                <option *ngFor="let vat of listVatPattern" [value]="vat.idVatPattern">
                                    {{ vat.vatPatternTraductionDto?.[0]?.description }}
                                </option>
                            </select>
                        </div>
                    </div>
                </form>
                <div class="row d-flex">
                    <div class="col-12 mt-4">
                        <button type="button" class="btn cancelbutton"
                            (click)="selectedMaterialPricesRowId = isClone = false ">
                            {{ 'academicTaxes.cancel' | translate }}
                        </button>
                        <button type="button" class="btn custombutton ms-2" (click)="savePriceRecord()">
                            {{ (selectedMaterialPricesRowId && !isClone) ? ('academicTaxes.modify' | translate ) :
                            'academicTaxes.save' | translate}}
                        </button>
                    </div>
                </div>

            </div>
        </div>
        <app-alert-component [isOk]="isCreatedMaterialPrices" [isDanger]="isErrorMaterialPrices"
            [message]="errorMessage"
            (close)="this.isCreatedMaterialPrices = isErrorMaterialPrices = false"></app-alert-component>
        <div *ngIf="selectedRowId">
            <div>
                <div class="separator mt-4"></div>
                <div class="row mt-4 mb-3">
                    <h2 class="mb-3 textformat col-8"> {{'navbar.discounts' | translate}}
                    </h2>
                    <div class="text-end d-flex align-items-center col-4 mt-2 justify-content-end">
                        <button type="button" class="btn custombutton"
                            (click)="newAcademicDiscount()">{{'academicTaxes.newRegister' | translate}}</button>
                    </div>
                </div>
            </div>

            <div>
                <fieldset>
                    <table id="table2" class="table" role="table" [attr.aria-label]="'navbar.discounts' | translate">
                        <thead role="rowgroup">
                            <tr role="row">
                                <th scope="col" role="columnheader">
                                    <span class="visually-hidden">{{ 'seleccionarFila' | translate }}</span>
                                </th>
                                <th scope="col" role="columnheader">{{'discount.codeDiscount' | translate}}</th>
                                <th scope="col" role="columnheader">{{'academicTaxes.discount' | translate}}</th>
                                <th scope="col" role="columnheader">{{'%'}}</th>
                                <th scope="col" role="columnheader">{{'academicTaxes.import' | translate}}</th>
                                <th scope="col" role="columnheader">{{'academicTaxes.order' | translate}}</th>
                                <th scope="col" role="columnheader">{{'academicTaxes.registrationDate' | translate}}
                                </th>
                                <th scope="col" role="columnheader">{{'academicTaxes.endDate' | translate}}</th>
                            </tr>
                        </thead>
                        <tbody role="rowgroup">
                            <tr *ngFor="let row of this.ownRateDiscountResponse.IdOwnRateDiscountDto; let id=index"
                                [ngClass]="{ 'resaltado': selectedOwnRateDiscountId === row.idOwnRateDiscount}"
                                role="row">
                                <td role="cell">
                                    <input type="radio" id="radio-{{row.idOwnRateDiscount}}" name="checkbox3"
                                        [checked]="selectedOwnRateDiscountId === row.idOwnRateDiscount"
                                        (click)="toggleRowAcademicDiscount(row)" />
                                    <label [for]="'radio-' + row.idOwnRateDiscount" class="visually-hidden">
                                        {{ "seleccionarFilaCon" | translate }}:
                                        {{ 'discount.codeDiscount' | translate }} {{
                                        row.generalDiscountCatalogDto?.discountCode }},
                                        {{ 'academicTaxes.discount' | translate }}
                                        <ng-container
                                            *ngFor="let desc of row.generalDiscountCatalogDto?.generalDiscountCatalogTraductionDto">
                                            <span *ngIf="desc.languageDto?.code === currentLanguage">{{
                                                desc.discountDescription }}</span>
                                        </ng-container>,
                                        {{ '%' }} {{ row.discountPercentage }},
                                        {{ 'academicTaxes.import' | translate }} {{ row.fixedDiscountAmount }},
                                        {{ 'academicTaxes.order' | translate }} {{ row.discountOrderNumber }},
                                        {{ 'academicTaxes.registrationDate' | translate }} {{ row.startDate |
                                        date:'dd/MM/yyyy' }},
                                        {{ 'academicTaxes.endDate' | translate }} {{ row.endDate | date:'dd/MM/yyyy' }}
                                    </label>
                                </td>
                                <td role="cell">{{ row.generalDiscountCatalogDto?.discountCode }}</td>
                                <td role="cell">
                                    @for (desc of row.generalDiscountCatalogDto?.generalDiscountCatalogTraductionDto;
                                    track
                                    $index) {
                                    <span
                                        *ngIf="desc.languageDto?.code==currentLanguage">{{desc.discountDescription}}</span>
                                    }
                                </td>
                                <td role="cell">{{ row.discountPercentage }}</td>
                                <td role="cell">{{ row.fixedDiscountAmount}}</td>
                                <td role="cell">{{ row.discountOrderNumber }}</td>
                                <td role="cell">{{ row.startDate | date:'dd/MM/yyyy' }}</td>
                                <td role="cell">{{ row.endDate | date:'dd/MM/yyyy' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </fieldset>
                <!-- Controles de paginación -->
                <div class="mt-2" *ngIf="this.ownRateDiscountResponse.pageDto">
                    <app-paginator [isStart]="this.ownRateDiscountResponse.pageDto.start"
                        [isEnd]="this.ownRateDiscountResponse.pageDto.end"
                        [currentPage]="this.ownRateDiscountResponse.pageDto.currentPage"
                        [totalPages]="this.ownRateDiscountResponse.pageDto.pages"
                        [numberRecord]="this.ownRateDiscountResponse.pageDto.records"
                        [sizePage]="this.ownRateDiscountResponse.pageDto.pageSize">
                    </app-paginator>
                </div>

                <div *ngIf="selectedOwnRateDiscountId || isCreatedOwnRateDiscount">
                    <div>
                        <div class="separator mt-5"></div>
                        <h2 class="mb-3 mt-4 textformat"> {{'navbar.discounts' |
                            translate}}</h2>
                    </div>
                    <form [formGroup]="formDiscount">
                        <div class="row">
                            <div class="mb-3 col-6 ">
                                <label for="idGeneralDiscountCatalog" class="form-label">{{'academicTaxes.discount'
                                    |translate}}<span>
                                        *</span></label>
                                <select class="form-select" id="idGeneralDiscountCatalog"
                                    name="idGeneralDiscountCatalog" formControlName="idGeneralDiscountCatalog"
                                    (change)="changeDescompte()">
                                               @for (discount of this.discountRateModelResponse.discountRateModelCatalogDto; track $index) {
                                        @if(isDiscountValid(discount.generalDiscountCatalogDto?.discountCode) || !isCreatedOwnRateDiscount) {
                                    <option
                                        [value]="discount.discountRateModelCatalogPkDto?.generalDiscountCatalogId">
                                        <span>{{discount.generalDiscountCatalogDto?.discountCode}} - <span>{{
                                                getDiscountDescription(discount.generalDiscountCatalogDto?.idGeneralDiscountCatalog)
                                                }}</span>
                                        </span>
                                    </option>
                                }
                                }
                                </select>
                            </div>
                            <div class="mb-3 col-6">
                                <label for="discountOrderNumber" class="form-label">{{'academicTaxes.order' |
                                    translate}}<span>
                                        *</span></label>
                                <input type="number" class="form-control" id="discountOrderNumber"
                                    name="discountOrderNumber" formControlName="discountOrderNumber" />
                                <span *ngIf="message.length>0">{{'messageOrder' | translate}}
                                    <strong>{{message[0].generalDiscountCatalogDto.discountCode}}</strong> </span>
                            </div>
                            <div class="mb-3 col-6">
                                <label for="importType" class="form-label">{{'typesVat.type' |translate}}</label>
                                <select class="form-select" formControlName="importType" name="importType"
                                    id="importType">
                                    <option value="I">{{'academicTaxes.import' |translate}}</option>
                                    <option value="P">{{'typesVat.percentage' |translate}}</option>
                                </select>
                            </div>
                            @if (formDiscount.get('importType')?.value=='I') {
                            <div class="mb-3 col-6">
                                <label for="fixedDiscountAmount" class="form-label">{{'academicTaxes.import'
                                    |translate}}<span>
                                        *</span></label>
                                <input type="number" class="form-control" id="fixedDiscountAmount"
                                    name="fixedDiscountAmount" formControlName="fixedDiscountAmount" [min]="0" />
                            </div>
                            }
                            @if (formDiscount.get('importType')?.value=='P') {
                            <div class="mb-3 col-6">
                                <label for="discountPercentage" class="form-label">{{'typesVat.percentage'|
                                    translate}}<span>
                                        *</span></label>
                                <input type="number" class="form-control" id="discountPercentage"
                                    name="discountPercentage" formControlName="discountPercentage" [min]="0"
                                    [max]="100" />
                            </div>
                            }
                            <div class="mb-3 col-6">
                                <label for="startDate" class="form-label">{{'academicTaxes.registrationDate' |
                                    translate}}<span>
                                        *</span></label>
                                <input type="date" class="form-control" id="startDate" name="startDate"
                                    formControlName="startDate" />
                            </div>

                            <!-- Fecha de baja -->
                            <div class="mb-3 col-6">
                                <label for="endDate1" class="form-label">{{'academicTaxes.endDate'
                                    |translate}}</label>
                                <input type="date" class="form-control" id="endDate1" name="endDate1"
                                    formControlName="endDate" />
                            </div>
                        </div>
                        <div class="row d-flex">
                            <div class="col-12 mt-4">
                                <button type="button" class="btn cancelbutton"
                                    (click)="selectedOwnRateDiscountId = null; this.formDiscount.reset(); this.isCreatedOwnRateDiscount = false">{{'academicTaxes.cancel'
                                    |translate}}</button>
                                <button *ngIf="!selectedOwnRateDiscountId" type="button" class="btn custombutton ms-2"
                                    (click)="saveOwnRateDiscount()"> {{
                                    'academicTaxes.save' | translate
                                    }}</button>
                                <button *ngIf="selectedOwnRateDiscountId" type="button" class="btn custombutton ms-2"
                                    (click)="saveOwnRateDiscount()"> {{
                                    'academicTaxes.modify' | translate
                                    }}</button>
                            </div>
                        </div>

                    </form>
                </div>
                <app-alert-component [isDanger]="isErrorOwnRateDiscount" [isOk]="isCreateOwnRateDiscount"
                    [message]="errorMessage"
                    (close)="this.isCreateOwnRateDiscount = this.isErrorOwnRateDiscount = false"></app-alert-component>
            </div>
        </div>
    </main>
</div>